import { CurrencyCode } from "@/types/deal";

export const currencies: {
  code: CurrencyCode;
  symbol: string;
  label: string;
}[] = [
  { code: "EUR", symbol: "€", label: "EUR (€)" },
  { code: "GBP", symbol: "£", label: "GBP (£)" },
  { code: "USD", symbol: "$", label: "USD ($)" },
];
